<template>
  <span v-if="!valueList.length" class="dict-tag dict-tag--empty">-</span>
  <span v-else class="dict-tag-list" :style="listStyle">
    <template v-for="(item, index) in resolvedTags">
      <el-tag
        v-if="tag"
        :key="'tag-' + index + '-' + item.value"
        size="small"
        :type="item.customColor ? undefined : item.tagType"
        :effect="item.customColor ? 'plain' : undefined"
        disable-transitions
        class="dict-tag"
        :class="{ 'dict-tag--custom': !!item.customColor }"
        :style="item.customStyle"
      >
        {{ item.label }}
      </el-tag>
      <span
        v-else
        :key="'text-' + index + '-' + item.value"
        class="dict-tag dict-tag--text"
      >
        {{ item.label
        }}<template v-if="index < resolvedTags.length - 1">、</template>
      </span>
    </template>
  </span>
</template>

<script>
import { getDictOptions, getDictItem } from "@/utils/dict";
import { getQuestionTypeColor } from "@/utils/questionTypeColors";

const TAG_TYPE_MAP = {
  primary: "",
  default: "",
  success: "success",
  info: "info",
  warning: "warning",
  danger: "danger"
};

/**
 * 芋道风格字典标签：支持单值 / 逗号分隔多值 / 数组
 */
export default {
  name: "DictTag",
  props: {
    type: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean, Array],
      default: ""
    },
    /** 是否渲染为 el-tag；false 时纯文本回显 */
    tag: {
      type: Boolean,
      default: true
    },
    /** 字符串多值分隔符 */
    separator: {
      type: String,
      default: ","
    },
    /** 多个 tag 间距 */
    gutter: {
      type: String,
      default: "6px"
    }
  },
  computed: {
    valueList() {
      const val = this.value;
      if (val === null || val === undefined || val === "") return [];
      if (Array.isArray(val)) {
        return val.map(String).map(s => s.trim()).filter(Boolean);
      }
      if (typeof val === "number" || typeof val === "boolean") {
        return [String(val)];
      }
      return String(val)
        .split(this.separator)
        .map(s => s.trim())
        .filter(Boolean);
    },
    listStyle() {
      if (!this.tag) return null;
      return {
        display: "inline-flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: this.gutter
      };
    },
    resolvedTags() {
      const options = getDictOptions(this.type);
      return this.valueList.map(value => {
        const hit =
          options.find(d => String(d.dictValue) === String(value)) ||
          getDictItem(this.type, value);
        const label = hit ? hit.dictLabel : String(value);
        const styleKey = hit
          ? hit.cssClass || hit.listClass || hit.colorType
          : "";
        const customColor = getQuestionTypeColor(this.type, value);
        return {
          value,
          label,
          tagType: TAG_TYPE_MAP[styleKey] || "",
          customColor,
          customStyle: customColor
            ? {
                color: customColor.color,
                backgroundColor: customColor.background,
                borderColor: customColor.borderColor
              }
            : null
        };
      });
    }
  }
};
</script>

<style scoped>
.dict-tag--empty,
.dict-tag--text {
  color: inherit;
}

.dict-tag--custom {
  font-weight: 500;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/DictTag.vue